module.exports = __webpack_public_path__ + "static/e-commerce-continuously-thriving-9ad89a96b5d9b06f086dd4bae5c1bdbf.png";